import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';

/*
import cloud1 from '../img/cloud1.png'
import cloud2 from '../img/cloud2.png'
import cloud3 from '../img/cloud3.png'
*/


export class QATools extends Component {
  constructor(props) {
    super(props)

    this.EXPANDED_FONT_SIZE = 46
    this.NORMAL_FONT_SIZE = 34
    this.MAX_FONT_DIFF = this.EXPANDED_FONT_SIZE - this.NORMAL_FONT_SIZE

    //this.ANIM_DECREMENT = 0.05
    this.ANIM_DECREMENT = 0.12
    this.ANIM_STEPS = 1.0 / this.ANIM_DECREMENT
    this.ANIM_INTERVAL_MS = 15
    this.ANIM_DURATION = this.ANIM_STEPS * this.ANIM_INTERVAL_MS


    this.state = {
      showApps: false,
      animWasTriggered: false,
      animInProgress: false,
      animPct: 1.0,
      animStartTime: null,
      animElapsed: 0,
      whichAppHovered: "none",
    }

    this.animIntervalId = null;

    this.startAnimation = this.startAnimation.bind(this)
    this.stopAnimation = this.stopAnimation.bind(this)
    this.doAnimInterval = this.doAnimInterval.bind(this)

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderApps = this.renderApps.bind(this)
    this.getAnimatedDivStyle = this.getAnimatedDivStyle.bind(this)
    this.getExpandedParentStyle = this.getExpandedParentStyle.bind(this)
    this.getElementStyle = this.getElementStyle.bind(this)

    this.parentDiv = this.parentDiv.bind(this)
    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    //console.log("QATools hovered() for id: " + elem.target.id)
    if ( elem.target.id === "qa-tools-closed" ) {
      if ( ! this.state.animWasTriggered ) {
        this.startAnimation()
      }
    } else if ( elem.target.id === "appiumario-anchor" ) {
      this.setState({
        whichAppHovered: "appiumario"
      })
    } else if ( elem.target.id === "smd-anchor" ) {
      this.setState({
        whichAppHovered: "smd"
      })
    }
  }


  unHovered(elem) {
    //
    // 22 May 2019
    // multiple unHover events happen at the bottom of the mobile apps container
    // any one of them needs to kill the expansion
    //
    //console.log("QATools unHovered() for elem: "+ elem.target.id)
    const triggers = [ "qa-tools-expanded-container", "bottom-apps-div", "mockingbird-anchor" ]
    if ( triggers.includes(elem.target.id ) ) {
      this.props.unBlurFunc()
      this.stopAnimation()
      this.setState({
        showApps: false,
        animWasTriggered: false,
        whichAppHovered: "none"
      })
    }
  }


  getAnimatedDivStyle() {
    let fontSize = this.NORMAL_FONT_SIZE

    if ( this.state.animInProgress ) {
      const currentDiffSize = this.MAX_FONT_DIFF * ( 1 - this.state.animPct )
      //console.("animating with currentDiffSize: " + currentDiffSize)
      fontSize = this.NORMAL_FONT_SIZE + currentDiffSize
      //console.log("animating with fontSize: " + fontSize)
    } else if ( this.state.animWasTriggered  ) {
      fontSize = this.EXPANDED_FONT_SIZE
    }

    const out = {
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      //border: "2px solid #443321",
      border: "2px solid #1F557D",
      padding: "10px",
      paddingTop: "15px",
      fontFamily: "BeyondInfinity",
      fontSize: `${fontSize}px`,
      marginLeft: "5px",
      marginRight: "5px",
    }
    return out
  }

  getExpandedParentStyle() {
    const out = {
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      background: "#ffffff",
      border: "2px solid #443321",
      padding: "10px",
      paddingTop: "15px",
      marginLeft: "5px",
      marginRight: "5px",
    }
    return out
  }

  getElementStyle() {
    const elementStyle = {
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      fontFamily: "BeyondInfinity",
      fontSize: `${this.EXPANDED_FONT_SIZE}px`,
      marginLeft: "5px",
      marginRight: "5px",
    }

    return elementStyle
  }



  parentDiv() {
    //console.log("parentDiv() with trigger: " + this.props.whichBoxWasTriggered)

    let divStyle = this.props.unBlurredStyle
    if ( this.state.animWasTriggered ) {
      divStyle = this.getAnimatedDivStyle()
    } else if ( this.props.whichBoxWasTriggered !== "none" ) {
      divStyle = this.props.blurredStyle
    }

    divStyle = this.props.unBlurredStyle

    //console.log("parentDiv divStyle: " + JSON.stringify(divStyle))

    return (
      <div id="qa-tools-closed"
        style={divStyle}
        onMouseOver={ this.hovered }
      >
        QA Tools
      </div>
    )
  }

  doAnimInterval() {
    //console.log("doAnimInterval() id: " + this.animIntervalId + " elapsed: " + this.state.animElapsed + " duration: " + this.ANIM_DURATION)

    if ( this.state.animElapsed >= this.ANIM_DURATION ) {
      //console.log("animPct <= 0")
      this.stopAnimation()
    } else {
      // issues with when number gets close to 0. Maybe a JS float problem.
      let newPct = this.state.animPct - this.ANIM_DECREMENT
      let newElapsedTime = this.state.animElapsed + this.ANIM_INTERVAL_MS
      if ( newPct < 0.01 ) {
        newPct = 0.0
      }
      //console.log(`animation interval decremented animPct: ${newPct}`)
      this.setState({
        animPct: newPct,
        animElapsed: newElapsedTime,
      })
    }
  }

  startAnimation() {
    if ( ! this.state.animWasTriggered ) {
      this.props.blurFunc("mobile-apps")

      this.animIntervalId = setInterval(() =>
        this.doAnimInterval(),
        this.ANIM_INTERVAL_MS
      )

      this.setState({
        animWasTriggered: true,
        animInProgress: true,
        animStartTime: Date.now(),
      })
    }
  }

  stopAnimation(elem) {
    //console.log("stopAnimation() for animIntervalId: " + this.animIntervalId)

    clearInterval(this.animIntervalId)

    this.setState({
      showApps: true,
      animInProgress: false,
      animStartTime: null,
      animElapsed: 0,
      animPct: 1.0,
    })
  }

  renderApps() {

    let titleStyle = {}
    Object.assign(titleStyle, this.getElementStyle())
    titleStyle.textDecoration = "underline"
    titleStyle.fontSize = this.NORMAL_FONT_SIZE - 4
    titleStyle.fontWeight = "bold"
    titleStyle.marginBottom = "16px"
    //titleStyle.color = "#1F557D"


    return (
      <div
        id="qa-tools-expanded-container"
        style={ this.getExpandedParentStyle() }
        onMouseLeave={ this.unHovered }
      >
        {/*
            // adding this piece causes the mousehover misalignment
        <div style={titleStyle}>
          QA Tools
        </div>
        */}
        <div
          style={this.getElementStyle()}
        >
          <a
            href="http://github.com/SeanFelipe/Appiumario"
            id="appiumario-anchor"
            onMouseOver={ this.hovered }
          >
            Appiumario
          </a>
        </div>

        <div
          style={this.getElementStyle()}
        >
          <a
            href="http://github.com/SeanFelipe/SuperMarioDroid"
            id="smd-anchor"
            onMouseOver={ this.hovered }
          >
            Super Mario Droid
          </a>
        </div>
      </div>
    )
  }


  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const descriptions = {
      'appiumario' : `
        Better mobile app automated testing with Appium and Mobile Prism
      `,
      'smd' : `
        An Android app for demonstrating the Appiumario framework.
      `,
      'mockingbird' : `
        Serves up static JSON files to mock your api. A better fake mousetrap.
      `,
      'interlocutor' : `
        Grab a live api stream, and modify individual fields on-the-fly. A great tool to easily recreate error conditions or edge cases.
      `,
    }

    const appNames = {
      'appiumario'  : 'Appiumario',
      'mockingbird' : 'Mockingbird',
      'interlocutor': 'Interlocutor',
      'smd'         : 'Super Mario Droid',
    }

    return (
      <div className="app-description-box">
        <h4>{ appNames[ this.state.whichAppHovered] }</h4>
        { descriptions[this.state.whichAppHovered] }
      </div>
    )
  }


  render() {

    return (
      <div>
        <div>
          { this.state.showApps
              ? this.renderApps()
              : this.parentDiv()
          }
        </div>
        <div>
          { this.state.whichAppHovered !== "none"
              ? this.renderAppDescriptionBox()
              :null
          }
        </div>
      </div>
    )
  }
}
